import { render, staticRenderFns } from "./FormOwner.vue?vue&type=template&id=c1ea18ce&scoped=true"
import script from "./FormOwner.vue?vue&type=script&lang=js"
export * from "./FormOwner.vue?vue&type=script&lang=js"
import style0 from "./FormOwner.vue?vue&type=style&index=0&id=c1ea18ce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ea18ce",
  null
  
)

export default component.exports